module.exports = __webpack_public_path__ + "static/media/label-3-over.419dd140.svg";